var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
    },
    [
      _c("div", { staticClass: "fixed inset-0 transition-opacity" }, [
        _c("div", {
          staticClass: "absolute inset-0 bg-gray-500 opacity-75",
          on: { click: _vm.close }
        })
      ]),
      _c(
        "div",
        {
          staticClass:
            "relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "modal-headline"
          }
        },
        [
          _c("div", { staticClass: "sm:flex sm:items-start" }, [
            _c(
              "div",
              { staticClass: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" },
              [
                _c(
                  "h3",
                  {
                    staticClass: "text-lg leading-6 font-medium text-gray-900",
                    attrs: { id: "modal-headline" }
                  },
                  [_vm._v(" Create " + _vm._s(_vm.templateType) + " Template ")]
                ),
                _c("div", { staticClass: "mt-2" })
              ]
            )
          ]),
          _c("div", { staticClass: "sm:ml-4 mt-4" }, [
            _c("div", [
              _c(
                "label",
                {
                  staticClass:
                    "block text-sm font-medium leading-5 text-gray-700",
                  attrs: { for: "email" }
                },
                [_vm._v(" Name ")]
              ),
              _c("div", { staticClass: "mt-1 relative rounded-md shadow-sm" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.name,
                      expression: "name"
                    }
                  ],
                  ref: "name",
                  staticClass:
                    "bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal",
                  attrs: { type: "text", placeholder: "Discount template" },
                  domProps: { value: _vm.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.name = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "mt-4" }, [
              _c(
                "label",
                {
                  staticClass:
                    "block text-sm font-medium leading-5 text-gray-700",
                  attrs: { for: "email" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex justify-between items-center my-2" },
                    [
                      _c("span", [_vm._v("Content")]),
                      _c("InsertVariableDropdown", {
                        attrs: { templateType: _vm.templateType },
                        on: { onItemClicked: _vm.insertAtCursor }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c("div", { staticClass: "mt-1 relative rounded-md shadow-sm" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.body,
                      expression: "body"
                    }
                  ],
                  ref: "content",
                  staticClass:
                    "bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal",
                  staticStyle: { "min-height": "240px" },
                  attrs: { type: "text" },
                  domProps: { value: _vm.body },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.body = $event.target.value
                    }
                  }
                })
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse" },
            [
              _c(
                "span",
                {
                  staticClass:
                    "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
                },
                [
                  !_vm.template
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5",
                          attrs: { type: "button" },
                          on: { click: _vm.onCreate }
                        },
                        [_vm._v(" Create ")]
                      )
                    : _vm._e(),
                  _vm.template
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5",
                          attrs: { type: "button" },
                          on: { click: _vm.onEdit }
                        },
                        [_vm._v(" Update ")]
                      )
                    : _vm._e()
                ]
              ),
              _c(
                "span",
                {
                  staticClass:
                    "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5",
                      attrs: { type: "button" },
                      on: { click: _vm.close }
                    },
                    [_vm._v(" Cancel ")]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }